(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-reference"] && !Shopify.designMode) return;
  try {
    
function initOrbitReference(){document.querySelectorAll('[data-orbit-reference]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const input=root.querySelector('input[name="quantity"]');const update=()=>{const qty=input?Math.max(1,Math.min(Number(input.max)||999,Number(input.value)||1)):1;if(input)input.value=qty;const text='Hi Michael, I would like to enquire about '+qty+' pack'+(qty===1?'':'s')+' of Orbit GR 2 kg, availability and delivery.';root.querySelectorAll('[data-whatsapp]').forEach(link=>link.href='https://wa.me/27765205555?text='+encodeURIComponent(text));};root.querySelectorAll('[data-quantity]').forEach(button=>button.addEventListener('click',()=>{input.value=(Number(input.value)||1)+Number(button.dataset.quantity);update();}));if(input)input.addEventListener('change',update);root.querySelectorAll('[data-site]').forEach(link=>link.addEventListener('click',()=>{root.querySelector('[data-site-whatsapp]').href='https://wa.me/27765205555?text='+encodeURIComponent('Hi Michael, please confirm the registered permitted uses and suitability of Orbit GR for '+link.dataset.site.toLowerCase()+'.');}));root.querySelectorAll('.or2-menu nav a').forEach(link=>link.addEventListener('click',()=>root.querySelector('.or2-menu').removeAttribute('open')));update();});}initOrbitReference();document.addEventListener('shopify:section:load',initOrbitReference);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orbit-storefront"] && !Shopify.designMode) return;
  try {
    
function initOrbit(){document.querySelectorAll('.orbit').forEach(root=>{const input=root.querySelector('.orbit-quantity');const total=root.querySelector('.orbit-subtotal');const link=root.querySelector('.orbit-whatsapp');if(!input||input.dataset.ready)return;input.dataset.ready='1';const update=()=>{const quantity=Math.min(99,Math.max(1,Math.floor(Number(input.value)||1)));input.value=quantity;total.textContent='R'+(quantity*800).toLocaleString('en-ZA');const text="Hi Michael, I'd like to enquire about "+quantity+" pack(s) of Orbit GR 2 kg. Product subtotal: R"+(quantity*800)+". Please confirm availability, suitability for my site, and delivery.";link.href='https://wa.me/'+link.dataset.phone+'?text='+encodeURIComponent(text);};input.addEventListener('change',update);link.addEventListener('click',update);update();});}initOrbit();document.addEventListener('shopify:section:load',initOrbit);

  } catch(e) { console.error(e); }
})();
})();
